/**
 * R58-W-12 — NotificationBell.
 *
 * Lives in the app chrome. Polls `/notifications/unread-count` every 30s
 * (per OQ-resolved polling interval). Click → opens the
 * `NotificationsDrawer`. Renders a badge with the unread count.
 */
import { useState, type ReactElement } from "react";
import { Badge, IconButton, Tooltip } from "@mui/material";
import { useUnreadCount } from "./queries.js";
import { NotificationsDrawer } from "./NotificationsDrawer.js";
import { BellIcon } from "@aeriosiq/ui/icons";

export function NotificationBell(): ReactElement {
  const [open, setOpen] = useState(false);
  const { data } = useUnreadCount();
  const unread = data?.unreadCount ?? 0;

  return (
    <>
      <Tooltip
        title={unread === 0 ? "Notifications" : `${String(unread)} unread`}
      >
        <IconButton
          aria-label={
            unread === 0
              ? "Notifications"
              : `Notifications — ${String(unread)} unread`
          }
          data-testid="notification-bell"
          onClick={() => {
            setOpen(true);
          }}
          size="small"
        >
          <Badge
            badgeContent={unread}
            color="primary"
            overlap="circular"
            invisible={unread === 0}
            max={99}
          >
            <BellIcon fontSize="small" />
          </Badge>
        </IconButton>
      </Tooltip>
      <NotificationsDrawer
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      />
    </>
  );
}
